import { defineComponent, computed } from "vue";
import ColorSelector from "./component-library7.mjs";
import VariantSelectorBasic from "./component-library495.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "variant-selector",
  props: {
    isAccessible: { type: Boolean, default: true },
    displayName: { default: "Varianten" },
    hideName: { type: Boolean },
    type: { default: "text" },
    variants: { default: () => [] }
  },
  emits: ["select-variant"],
  setup(__props) {
    const props = __props;
    const isColorSelector = computed(() => props.type === "COLOR");
    const activeVariantIndex = computed(
      () => props.variants.findIndex((v) => v.active)
    );
    const activeVariantName = computed(() => {
      var _a;
      return ((_a = props.variants[activeVariantIndex.value]) == null ? void 0 : _a.name) || "";
    });
    return { __sfc: true, props, isColorSelector, activeVariantIndex, activeVariantName, VariantSelectorColor: ColorSelector, VariantSelectorBasic };
  }
});
export {
  _sfc_main as default
};
